import { useContext } from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { HeaderTableCell } from 'components/TransactionsSection/table/HeaderTableCell';
import UserTableRow from './UserTableRow/UserTableRow';
import { UserContext } from 'context/users/userContext';

const columns = [
    { id: 'name', label: 'USER NAME', minWidth: 170 },
    { id: 'contacts', label: 'CONTACTS', minWidth: 100 },
    {
        id: 'role',
        label: 'ROLE',
        minWidth: 170,
        align: 'left',
        format: value => value.toLocaleString('en-US')
    },
    {
        id: 'activeCards',
        label: 'ACTIVE CARDS',
        minWidth: 170,
        align: 'center',
        format: value => value.toLocaleString('en-US')
    },
    {
        id: 'status',
        label: 'STATUS',
        minWidth: 170,
        align: 'left',
        format: value => value.toFixed(2)
    },
    {
        id: 'kycStatus',
        label: 'KYC STATUS',
        minWidth: 170,
        align: 'left',
        format: value => value.toFixed(2)
    },
    {
        id: 'activeStatus',
        label: 'ACTIONS',
        minWidth: 170,
        align: 'center',
        format: value => value.toFixed(2)
    }
];

function UsersTable({ pagination, setPagination }) {
    const {
        state: { users, total }
    } = useContext(UserContext);

    const handlePageChange = (event, newPage) => {
        setPagination({ ...pagination, page: newPage });
    };

    const handleRowsPerPageChange = event => {
        setPagination({
            page: 0,
            rowsPerPage: Number(event?.target?.value)
        });
    };

    return (
        <Paper sx={{ width: '100%', overflow: 'hidden', marginTop: '1em' }}>
            <TableContainer>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            {columns.map(column => (
                                <HeaderTableCell value={column.label} key={column.label} position={column.align} index />
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {users?.map(user => (
                            <UserTableRow key={user.id} user={user} />
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[5, 10, 25, 100]}
                component="div"
                count={total}
                rowsPerPage={pagination.rowsPerPage}
                page={pagination.page}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleRowsPerPageChange}
            />
        </Paper>
    );
}

export default UsersTable;
